import styled from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const ContactHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
`;

const LoadingWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  height: 33vh;
`;

const VerticalLine = styled.div`
  background-color: var(--color-accent-secondary-weaker);
  height: 24px;
  margin-left: 24px;
  margin-right: 8px;
  width: 1px;
`;
const NavigationSecondaryContent = styled.div``;

export { ContactHeader, ContentWrapper, LoadingWrapper, NavigationSecondaryContent, VerticalLine };
